import type { TweetListResponsePageAllOfThreeContentItemBasicInfoAllOf } from './tweetListResponsePageAllOfThreeContentItemBasicInfoAllOf';
import type { TweetListResponsePageAllOfThreeContentItemBasicInfoAllOfTwo } from './tweetListResponsePageAllOfThreeContentItemBasicInfoAllOfTwo';

export type TweetListResponsePageAllOfThreeContentItemBasicInfo = TweetListResponsePageAllOfThreeContentItemBasicInfoAllOf & TweetListResponsePageAllOfThreeContentItemBasicInfoAllOfTwo;
